import STORE from '../STORE';
import { API } from '@/utils/api';

const { actions } = STORE.modules.globalSearch;
const { mutations: rootMutations } = STORE;

export default {
  namespaced: true,
  actions: {
    [actions.search]: async ({ dispatch }, searchString) => {
      try {
        let response = await API.get(`trials/?search=${searchString}&limit=10`);

        return response.data.results.map(
          (item) => ({ ...item, fullname: `${item.fullname} (id:${item.id})` })
        ).sort(
          // trial with id==searchString make first
          (a, b) => (`${a.id}` === searchString ? -1 : (`${b.id}` === searchString ? 1 : 0)
          ));
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('failed', e.response);
      }
    },
  },
};
